import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarDadosControleGerencial(api, parametros) {
    parametros.operacao = 'buscarDadosControleGerencial';

    let retorno = {};

    await api.santriGET('/rest/controleGerencial', parametros, 40, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async buscarDadosPainelVendasControleGerencial(api, parametros) {
    parametros.operacao = 'buscarDadosPainelVendasControleGerencial';

    let retorno = {};

    await api.santriGET('/rest/controleGerencial', parametros, 40, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async buscarDadosVendasFormasPagamento(api, parametros) {
    parametros.operacao = 'buscarDadosVendasFormasPagamento';

    let retorno = {};

    await api.santriGET('/rest/controleGerencial', parametros, 40, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RControleGerencial.js